import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * Emits each time the host element scrolls into view.
 * Unlike window scroll listeners, it also works inside scrolled containers such as mat-drawer-content.
 * A newly rendered host that is already visible emits right away.
 */
@Directive({ selector: '[inViewport]' })
export class InViewportDirective implements OnInit, OnDestroy {
    @Output() inViewport = new EventEmitter<void>();
    private observer: IntersectionObserver;

    constructor(private el: ElementRef<HTMLElement>, private ngZone: NgZone) {}

    ngOnInit() {
        this.observer = new IntersectionObserver((entries) => this._intersectionCallback(entries));
        this.observer.observe(this.el.nativeElement);
    }

    _intersectionCallback(entries: Pick<IntersectionObserverEntry, 'isIntersecting'>[]) {
        if (entries.some((entry) => entry.isIntersecting)) {
            // Emit inside Angular so listeners' views get change detection.
            this.ngZone.run(() => this.inViewport.emit());
        }
    }

    ngOnDestroy() {
        this.observer.disconnect();
    }
}
